import { Button } from '@usealloy/component-library';
import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';


const AccordionPropTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  doesBodyHaveMargin: PropTypes.bool,
  isOpen: PropTypes.bool,
  hasTopLine: PropTypes.bool,
};
const AccordionDefaultProps = {
  title: '',
  isOpen: true,
  children: null,
  hasTopLine: true,
  doesBodyHaveMargin: true,
};

/**
 * @deprecated Please use the Collapse component from the Component Library
 */
function Accordion({
  children, title, isOpen, doesBodyHaveMargin, hasTopLine,
}) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(isOpen);
  const onToggle = () => { setIsAccordionOpen(!isAccordionOpen); };
  const iconClasses = isAccordionOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
  return (
    <>
      <Button className="accordion-button" onClick={onToggle}>
        <i className={iconClasses} />
        <p className="very-bold">{title}</p>
      </Button>
      <div className={`collapse-container ${doesBodyHaveMargin ? '' : 'no-margin'}`}>
        { hasTopLine && <hr />}
        <Collapse isOpen={isAccordionOpen}>
          {children}
        </Collapse>
      </div>
    </>
  );
}
Accordion.propTypes = AccordionPropTypes;
Accordion.defaultProps = AccordionDefaultProps;

export default Accordion;
